import React from "react";
import Navbar from "../Navbar/Navbar";
import Header from "../Header/Header";
//import All from "../Header/AllInOne";
import WhoWeAre from "../WhoWeAre/WhoWeAre";
import Product from "../Products/Products";
import Trending from "../Trending/Trending";
import Numbers from "../Numbers/Numbers";
import Contact from "../Contact/Contact";
import FAQ from "../FAQ/FAQ";
import Testimonials from "../Testimonials/Testimonials";
import Footer from "../Footer/Footer";
//import Header from "../Header/Header";
//import All from "../Header/AllInOne";





const Home = () => {
    return(
    <>
   <Navbar/>
   <Header/>
   <WhoWeAre/>
   <Product/>
   <Trending/>
   <Numbers/>
   <Contact/>
   <FAQ/>
   <Testimonials/>
   <Footer/>
 
    </>
    )
}

export default Home;